var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKdb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_KDB 1",
    clipPath: "url(#clip0_1736_9971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9562 0.012652C5.33599 0.311096 0.211098 5.91999 0.512654 12.5415C0.81421 19.1631 6.42177 24.2853 13.0429 23.9875C19.664 23.6898 24.788 18.0764 24.4873 11.4567C24.1867 4.83687 18.5787 -0.288904 11.9562 0.012652Z",
    fill: "#002CB2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.19344 10.7492C7.83789 10.1937 7.549 9.03656 7.83144 8.47656L5.48433 12.1543C5.24433 12.5335 5.23233 13.1543 5.48433 13.5463L8.15411 17.7419C8.39411 18.1139 8.94878 18.4361 9.51344 18.4361H13.0912L8.19344 10.7492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.06481 8.11076C7.8037 8.79253 8.20393 10.0534 8.51637 10.5416L9.79859 12.4928C9.82123 12.4122 9.85464 12.335 9.89793 12.2634L13.0275 7.32031H9.50904C8.88504 7.32031 8.39126 7.5952 8.1257 8.01631L8.06481 8.11076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.93799 11.918L9.84754 13.3451L8.93799 11.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.8066 13.2513C17.1633 13.8069 17.451 14.964 17.1686 15.524L19.5157 11.8462C19.7557 11.4671 19.7677 10.8462 19.5157 10.4542L16.8459 6.25868C16.6062 5.88668 16.0513 5.56445 15.4866 5.56445H11.9102L16.8066 13.2513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.9353 15.8898C17.1964 15.208 16.7962 13.9471 16.4838 13.4589L15.2015 11.5078C15.1789 11.5884 15.1455 11.6655 15.1022 11.7371L11.9727 16.6805H15.4911C16.1151 16.6805 16.6089 16.4056 16.8744 15.9845L16.9353 15.8898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.0619 12.0834L15.1523 10.6562L16.0619 12.0834Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_9971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKdb);
export default __webpack_public_path__ + "static/media/kdb.f08351bf05bbe3595aaa64609f966eb6.svg";
export { ForwardRef as ReactComponent };